var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmsCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17563 0.170248L5.18341 4.17803L9.19119 0.170234C9.41817 -0.0567449 9.7862 -0.0567446 10.0132 0.170235C10.2402 0.397214 10.2402 0.765247 10.0132 0.992226L6.0054 5L10.0132 9.00779C10.2401 9.23477 10.2401 9.60279 10.0132 9.82976C9.78618 10.0567 9.41816 10.0567 9.19119 9.82976L5.18341 5.822L1.17564 9.82976C0.948656 10.0567 0.580637 10.0567 0.353658 9.82976C0.126679 9.60279 0.126679 9.23477 0.353658 9.00779L4.36142 5L0.353645 0.992238C0.126666 0.76526 0.126666 0.397227 0.353645 0.170248C0.580624 -0.0567314 0.948656 -0.0567314 1.17563 0.170248Z",
    fill: "#2D3245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmsCrossIcon);
export default __webpack_public_path__ + "static/media/pms_cross_icon.305964a3f83148c6131f97212016b6ff.svg";
export { ForwardRef as ReactComponent };